import { classNames } from "primereact/utils";
import styles from "./OverflowingParagraph.module.scss";

interface IOverflowingParagraphProps {
  className?: string;
  content: string;
  /**
   * When true, enables adaptive behavior:
   * 1. Tries to reduce font size to fit
   * 2. If still too long, wraps to 2 lines
   * 3. If still too long, applies ellipsis
   */
  adaptive?: boolean;
}

export const OverflowingParagraph = ({
  className,
  content,
  adaptive = false,
}: IOverflowingParagraphProps) => {
  return (
    <p
      className={classNames(
        styles.root,
        adaptive && styles.adaptive,
        className
      )}
    >
      {content}
    </p>
  );
};
